import { catchError, firstValueFrom, mergeMap, Observable, of } from 'rxjs';

export interface IResult<T> {
  isSuccess?: boolean;
  value?: T;
  message?: string;
  statusCode?: number;
  detail?: string;
  errors?: any[];
}

export async function resultFrom<T>(response: Observable<T>) {
  const result = await firstValueFrom(
    response.pipe(
      mergeMap((value) => of(Result.success<T>(value))),
      catchError((err) =>
        of(
          Result.failure<T>({
            message: err.message,
            statusCode: err.status,
            detail:
              err.error?.detail?.replace('Next error(s) occurred:', '').replace('\n', '<br>') ||
              err.error?.message ||
              err.error ||
              err.statusText,
            errors: Array.isArray(err.error) ? err.error : err.error?.errors ? [err.error.errors] : undefined
          })
        )
      )
    )
  );
  console.log('resultFrom', result);
  return result;
}

export class Result<T> implements IResult<T> {
  isSuccess: boolean;
  value?: T;
  message?: string;
  statusCode?: number;
  detail?: string;
  errors?: any[];

  constructor(options: IResult<T>) {
    this.isSuccess = options.isSuccess;
    this.value = options.value;
    this.message = options.message;
    this.statusCode = options.statusCode;
    this.detail = options.detail;
    this.errors = options.errors;
  }

  static success<T>(value: T): Result<T> {
    return new Result<T>({ isSuccess: true, value });
  }

  static failure<T>(options: IResult<T>): Result<T> {
    options.isSuccess = false;
    return new Result<T>(options);
  }
}
